<template>
    <div class="mb-5">
        <!--markdown-start-->
        <h3 class="bg-faded mt-3 pt-3 pb-3 " >导出Excel-markdown</h3>
        <h6>一、需要安装三个依赖：<code>file-saver</code> <code>xlsx</code> <code>script-loader</code></h6>
        <p class="mt-3 pl-3">
            1.
            <kbd>
                npm install -S file-saver xlsx
            </kbd>
        </p>
        <p class="mt-3 pl-3">
            2.
            <kbd>npm install -D script-loader</kbd>
        </p>
        <h6>二、项目中新建一个文件夹：（exportExcel---名字任取）</h6>
        <p class="mt-3 pl-3">放入文件Blob.js和 Export2Excel.js（百度下载）</p>
        <img src="static/blog/1.jpg" alt="">
        <h6>三、修改路径</h6>
        <img src="static/blog/20170624-0.png" alt="">
        <h6 class="pb-5 pt-3">四、参见源码  </h6>
        <!--markdown-end-->
    </div>
</template>
<!-- <script type="text/ecmascript-6"> -->
<script>
export default {
    data() {
            return {

            }
        },
        methods: {

        }
}
</script>
<style>
 img{max-width: 700px}
</style>



// WEBPACK FOOTER //
// exportExcel.vue?1d3ad76e